<template>
  <div class="customer-review">
  
    <employee-dialog v-model="employeeDialogMain" @select="setReviewApprove"></employee-dialog>
    <index-view title="Review nhân viên" :filters="filters" :getData="getData" :getDetail="getDetail" :headers="mainHeaders" 
    :detailWidth="1000" :cellSlots="cellSlots" tableKey="keyEmployeeCode">
      <template #viewSection="{ item, selected }" >
        <detail :item="item" :selected="selected"></detail>
      </template>
        
      <template v-slot:[`status`]="{ cell, reload }">
        <b :key="'status'" :class="convertStatus(cell?.status).color">{{ convertStatus(cell?.status).text }}</b>
      </template>
      
      <template v-slot:[`totalScoreNvm`]="{ cell, reload }">
        <span :class="cell?.totalScoreNvm == cell?.totalMaxScoreNvm && cell?.totalMaxScoreNvm>0 ? 'green--text' : ''">{{ cell?.totalScoreNvm }}/{{ cell?.totalMaxScoreNvm }}</span>
      </template>
      
      <template v-slot:[`keyEmployeeHireDate`]="{ cell, reload }">
        <span>{{ $formatter.formatDate(cell?.keyEmployeeHireDate, 'DD/MM/YYYY') }}</span>
      </template>
      
      <template v-slot:[`totalScoreCot2`]="{ cell, reload }">
        <span :class="cell?.totalScoreCot2 == cell?.totalMaxScoreCot2 && cell?.totalMaxScoreCot2>0 ? 'green--text' : ''">
          {{ cell?.totalScoreCot2 }}/{{ cell?.totalMaxScoreCot2 }}
        </span>
        
      </template>
      
      <template v-slot:[`approvedByCode`]="{ cell, reload }">
      <b>{{ cell?.approvedByCode }}</b>
      <p class="my-0 green--text"  @click="employeeDialogMain=true, selected = cell" style="cursor: pointer;"> <u><small>Thay đổi</small></u></p>
      </template>

      <template #action1>
        <v-btn text color="red" style="text-transform: none;" small class="mx-1" @click="action1Dialog=true">Chốt kỳ</v-btn>
        <v-dialog v-model="action1Dialog" max-width="800">
          <v-card class="rounded-lg">
            <v-card-title class="text-subtitle-1">
              Chốt kỳ đánh giá nhân viên
              <v-spacer></v-spacer>
              <v-btn icon color="red" @click="action1Dialog=false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
            <v-row>
              <v-col cols="12">
                <!-- <v-text-field v-model="actionData.month" label="Kỳ chốt" placeholder="" persistent-placeholder type="date" outlined>
                </v-text-field> -->
                
                  <v-select label="Chọn năm" v-model="sessionYear" placeholder="" persistent-placeholder hide-details :items="yearOptions"></v-select>
                  
              </v-col>
            </v-row>
            <v-data-table :headers="finalHeaders" :items="finals">
            
              <template v-slot:item.status="{ item }">
                <v-icon v-if="item.status" color="green">mdi-check</v-icon>
              </template>
              
              <template v-slot:item.setFinal="{ item }">
                <v-btn x-small v-if="!item.status" color="teal darken-4" @click="actionSubmit(item)" dark style="text-transform: none;"> 
                  <v-icon left>mdi-check</v-icon>
                  Chốt kỳ
                </v-btn>
              </template>
              <template v-slot:item.resetFinal="{ item }">
                <v-btn x-small v-if="item.status" color="error" @click="actionRemove(item)" dark style="text-transform: none;"> 
                  <v-icon left>mdi-refresh</v-icon>
                  Reset
                </v-btn>
              </template>

              <!-- <template v-slot:item.actions="{ item }">
                <v-btn icon color="red" small @click="actionRemove(item)"> <v-icon>mdi-trash-can</v-icon></v-btn>
              </template> -->
            </v-data-table>
            </v-card-text>
            <!-- <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="teal darken-4" dark style="text-transform: none;" elevation="0" @click="actionSubmit"><v-icon left>mdi-check</v-icon> Chốt kỳ</v-btn>
            </v-card-actions> -->
          </v-card>
        </v-dialog>
      </template>

      <template #action2>
        <employee-dialog v-model="employeeDialog" @select="setEmployee"></employee-dialog>
        <v-btn small text color="cyan" style="text-transform: none;" type="button" @click="action2Dialog=true">Khởi tạo</v-btn>
        <v-dialog v-model="action2Dialog" scrollable width="1200">
          <v-card class="rounded-lg">
            <v-card-title class="text-subtitle-1">
              Khởi tạo đợt đánh giá nhân viên
              <v-spacer></v-spacer>
              <v-btn icon color="red" @click="action2Dialog=false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row class="mt-0">
                <v-col cols="6" md="3">
                  <v-date-picker locale="vi" color="green" 
                    v-model="action2Calendar"
                    type="month"
                  ></v-date-picker>
                </v-col>
                <v-col cols="12" md="9">
                  <v-text-field v-model="readySearch" label="Tìm kiếm" prepend-inner-icon="mdi-magnify" 
                  outlined hide-details style="max-width: 200px;" dense class="d-inline-flex"></v-text-field>

                  <v-btn text style="text-transform: none;" color="cyan" class="d-inline-flex ml-2 mb-2" small @click="initReady">Khởi tạo</v-btn>

                  <v-data-table :items="readies" :headers="readyHeaders" :search="readySearch" dense :loading="readyLoading">
                    <template v-slot:item.smCode="{ item }">
                      <span>{{ item.smCode }}</span> <a href="#" class="green--text" @click="employeeDialog=true, selected=item">Thay đổi</a>
                    </template>

                    <template v-slot:item.hireDate="{ item }">
                      {{ $formatter.formatDate(item?.hireDate, 'DD/MM/YYYY') }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="teal darken-4" dark 
              style="text-transform: none;" elevation="0" @click="generateReview">
                <v-icon left>mdi-check</v-icon> Tạo phiếu
              </v-btn>
            </v-card-actions>
            <v-card-subtitle class="red--text text-caption text-right">
            <b class="mr-2">Lưu ý: </b> Sau khi khởi tạo đợt đánh giá, <b>các phiếu đánh giá đã tồn tại trong tháng</b> sẽ bị xóa và không thể khôi phục.
            </v-card-subtitle>
          </v-card>
        </v-dialog>
      </template>
    </index-view>
    
  </div>
</template>

<script>

import IndexView from '../../../components/CommonView/IndexView.vue';
import { get, getDetailByEmployee, setFinal, getFinal, removeFinal, getFinalSession, getReady, setReady, initReady, generateReview, changeConfirmedBy, changeApprovedBy } from './api'
import { main, finalHeaders, readyHeaders } from './header'
import Detail from './Detail.vue'
import EmployeeDialog from '../../../components/Crud/Prompt/EmployeeDialog.vue';
import moment from 'moment';
const statusFilters = ['Tạo mới', 'Hoàn tất', 'Hủy']
export default {
  name: "CustomerReview",
  components: {
    IndexView,
    Detail,
    EmployeeDialog
  },
  computed: {
    mainHeaders () {
      return main(this.filters)
    },
    yearOptions() {
      let thisYear = moment().year();
      let lowerYear = thisYear - 5;
      let upperYear = thisYear + 5;
      var yearOptions = [];
      for(let y = lowerYear; y <= upperYear; y++) {
        yearOptions.push(y);
      }

      return yearOptions;
    }

  },
  data() {
    return {
      filters: [
        {name: 'id', label:'Id', type: 'text', value: '' },
        {name: 'keyEmployeeCode', label:'Mã NS', type: 'text', value: '' },
        {name: 'keyEmployeeName', label:'Tên NS', type: 'text', value: '' },
        // {name: 'status', label:'Trạng thái', type: 'select', selectItems: statusFilters, value: '' },
      ],
      cellSlots: ['status', 'approvedByCode', 'totalScoreNvm', 'totalScoreCot2', 'keyEmployeeHireDate'],
      selected: null,
      action1Dialog: false,
      actionData: {
        month: null
      },
      finals: [],
      finalHeaders : finalHeaders,
      sessionYear: moment().year(),

      action2Dialog: false,
      action2Calendar: null,
      readySearch: '',
      readies: [],
      readyHeaders: readyHeaders,
      readyLoading: false,

      employeeDialog: false,
      employeeDialogMain: false,
    }
  },
  watch: {
    action2Calendar(newVal) {
      this.getReady();
    },
    sessionYear(newVal) {
      this.getFinalSession();
    }
  },
  methods: {
    getData: get,
    getDetail: getDetailByEmployee,
    actionSubmit(item) {
      return setFinal(item.month).then(() =>{
        // this.action1Dialog = false;
      }).finally(() => {
        this.getFinalSession();
      })
    },
    actionRemove(item) {
      return removeFinal(item.month).then(() => {
        this.finals = this.finals.filter(i => i.month !== item.month)
      }).finally(() => {
        this.getFinalSession();
      })
    },
    getFinal() {
      return getFinal().then(data => {
        this.finals = data.data.map(item => {
          item.month = this.$formatter.formatDate(item.month, 'MM/YYYY')
          return item
        });
      })
    },

    getFinalSession() {
      return getFinalSession(this.sessionYear).then(data => {
        this.finals = data.data.map(item => {
          item.month = this.$formatter.formatDate(item.month, 'MM/YYYY')
          return item
        });
      })
    },

    //ready section
    getReady() {
      this.readyLoading =true
      return getReady(this.action2Calendar).then(data => {
        this.readies = data.data;
      }).finally(() => {
        this.readyLoading =false
      })
    },
    
    setReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return setReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    setEmployee(value) {
      var empObj = value[0]
      if(value.length == 0) {
        return changeConfirmedBy(this.selected.id, '').then(() => {
          this.selected.smCode = ''
          this.selected.smName = ''
          this.employeeDialog = false
        }).finally(() => {
          this.selected = null
        })
      }else {
        return changeConfirmedBy(this.selected.id, empObj.code).then(() => {
          this.selected.smCode = empObj.code
          this.selected.smName = empObj.name
          this.employeeDialog = false
        }).finally(() => {
          this.selected = null
        })
      }
    },
    setReviewApprove(value) {
      var empObj = value[0]
      if(value.length == 0) {
        return changeApprovedBy(this.selected.id, null).then(() => {
            this.selected.approvedByCode = null
            this.selected.approvedByName = null
            this.employeeDialogMain = false
          }).finally(() => {
            this.selected = null
          })
      }else {
        return changeApprovedBy(this.selected.id, empObj.code).then(() => {
          this.selected.approvedByCode = empObj.code
          this.selected.approvedByName = empObj.name
          this.employeeDialogMain = false
        }).finally(() => {
          this.selected = null
        })
      }
    },
    
    initReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return initReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },

    generateReview() {
      //call api to generate review for ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return generateReview(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    convertStatus(status) {
      if(status === 0) return {text:'Tạo mới', color:'cyan--text'}
      if(status === 1) return {text:'SM duyệt', color:'green--text'}
      if(status === 2) return {text:'Lưu trữ', color:'blue--text'}
      return {text:'Hủy', color:'red--text'}
    }
  },
  mounted() {
    // this.getFinal().then(d => {
    // });

    this.getFinalSession(2025)
  }
}
</script>